export default __webpack_public_path__ + "static/media/emotion-m@2x.53b72b6d.png";